export function getStage() {
  return (
    process.env.APP_ENV ||
    process.env.ENVIRONMENT ||
    process.env.NODE_ENV ||
    "development"
  ).toLowerCase();
}

export function getDbUri() {
  const direct = process.env.DB_URI?.trim?.();
  if (direct) return direct;

  const stage = getStage();
  const isProd = stage === "production" || stage === "prod";

  const uri = (
    isProd ? process.env.MONGODB_URI_PROD : process.env.MONGODB_URI_DEV
  )?.trim?.();
  return uri || "";
}

export const DB_URI = getDbUri();

export const ENABLE_BLOG =
  (process.env.NEXT_PUBLIC_ENABLE_BLOG || "").toLowerCase() === "true";
export const ENABLE_CHAT =
  (process.env.NEXT_PUBLIC_ENABLE_CHAT || "").toLowerCase() === "true";

/**
 * Validates that required environment variables are present
 * @param {string[]} requiredVars - Array of required environment variable names
 * @returns {Object} - Object with isValid flag and missing variables array
 */
export function validateEnvVars(requiredVars = []) {
  const missing = requiredVars.filter((varName) => !process.env[varName]);
  return {
    isValid: missing.length === 0,
    missing,
  };
}
